import React, {Component} from 'react';
import axios from "axios";



export default class SideBar extends Component {
 state = { menuGroups: [] }

 componentDidMount() {
    axios.get(localStorage.getItem('lorahost') + '/setting/getmymenus', {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    }).then(
      res => {
        this.setState({ menuGroups: res.data });
      }, err => {
        console.log(".....")
      }
    )

  }

  toggleSideLine(id) {
    if (document.getElementById(id).classList.contains("show")) {
      document.getElementById(id).classList.remove("show");
    }
    else {
      document.getElementById(id).classList.add("show");
    }
  }


      render() {
        return (

 <div id="sidebar-wrapper">
          
            {/* Logo Area */}
            <div className="sidebar-logo-area">
              <div>
                <h2 className="sidebar-logo-text">ECONET</h2>
                <p className="sidebar-logo-subtitle">Wireless</p>
              </div>
            </div>

            {/* Menu Groups */}
            <ul className="list-group list-unstyled ps-0">
              {this.state.menuGroups.map((menuGroup, index) => (
                <li className="mb-2" key={index}>
                  <button className="btn btn-toggle align-items-center rounded collapsed" data-bs-toggle="collapse" data-bs-target="#home-collapse" aria-expanded="false" onClick={e => this.toggleSideLine('m' + index)}>
                    {menuGroup.name}
                  </button>
                  <div className="collapse" id={'m' + index}>
                    <ul className="list-group btn-toggle-nav list-unstyled fw-normal pb-1">
                      {menuGroup.menus.map((menu, i) => (
                        <li key={i}>
                          <a href={menu.menuFunction} className="list-group-item text-white rounded sidebar-link-item">
                            <i className="bi bi-arrow-bar-right"></i> 
                            <span>{menu.name}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </li>
                
              ))}
              
            </ul>
          </div>

        )}
    }